import React from 'react';
import { Box, Typography } from '@mui/material';
import AddIcon from '@mui/icons-material/Add';
import FileDownloadIcon from '@mui/icons-material/FileDownload';
import DashboardIcon from '@mui/icons-material/Dashboard';
import type { UserAccessHeaderProps } from './types';
import './UserAccess.css';

export const UserAccessHeader: React.FC<UserAccessHeaderProps> = ({
  loading,
  filteredUsersCount,
  onAddUser,
  onExportUsers,
  onBackToDashboard,
}) => {
  return (
    <div className="user-access-header">
      <Typography variant="h6" sx={{ fontWeight: 400 }}>
        User Access Listing
      </Typography>
      <Box className="user-access-header__actions">
        <button
          className="user-access-action-btn"
          onClick={onAddUser}
          disabled={loading}
        >
          <AddIcon sx={{ fontSize: 16 }} />
          Add User
        </button>
        <button
          className="user-access-action-btn"
          onClick={onExportUsers}
          disabled={loading || filteredUsersCount === 0}
        >
          <FileDownloadIcon sx={{ fontSize: 16 }} />
          Export User
        </button>
        <button
          className="user-access-action-btn"
          onClick={onBackToDashboard}
          disabled={loading}
        >
          <DashboardIcon sx={{ fontSize: 16 }} />
          Back To Dashboard
        </button>
      </Box>
    </div>
  );
};